import type { MemoEntry, SectionHistoryEntry, UUID } from "@/lib/types";

// INVARIANT: an `is_historical` entry is ALWAYS `retired: true`. Read-only
// enforcement for click-to-edit and task controls keys off the retired lane
// (`entry.retired`), NOT off `is_historical` directly — so this pairing is
// load-bearing. A future non-retired historical entry would silently re-enable
// click-to-edit / task controls; gate those on `is_historical` too if that ever changes.
export function historyToEntry(h: SectionHistoryEntry, blockId: UUID): MemoEntry {
  return {
    id: h.id,
    block_id: blockId,
    position: h.position,
    kind: h.kind,
    log_date: h.log_date,
    body: h.body,
    retired: true,
    is_historical: true,
    retired_at: h.retired_at,
    assignee_user_id: h.assignee_user_id,
    due_date: null,
    row_id: null,
    task_done: h.task_done,
    task_solution: null,
  } as MemoEntry;
}

export function mergeSectionTimeline(current: MemoEntry[], history: MemoEntry[]): MemoEntry[] {
  const all = [...history, ...current];
  return all.slice().sort((a, b) => {
    const da = a.log_date ?? "";
    const db = b.log_date ?? "";
    if (da !== db) return da < db ? -1 : 1;
    return (a.position ?? 0) - (b.position ?? 0);
  });
}
